import moment from "moment-timezone";
import { base64Encode } from "../utils/base64";
import { buildContractReportQuery } from "./contractReportQuery";
import type { ArgAdapter, ContextInjection } from "./tools";

// listContractReports is the one endpoint whose `q` is a base64-encoded JSON query that must carry
// the org id — the model can't produce that, so the executor builds it from the real filter params
// the catalog advertises (see contractReportQuery.ts).
export const contractArgAdapters: Record<string, ArgAdapter> = {
  listContractReports: (args, ctx) => ({
    q: base64Encode(JSON.stringify(buildContractReportQuery(args, ctx.auth.organizationId))),
  }),
};

// createContract's depId and timezone are client context, not model input, so the catalog advertises
// only the title. The generic engine reads this declaration to fold the advertised body params under
// bodyKey, add the context defaults, and set the path params.
export const contractContextInjections: Record<string, ContextInjection> = {
  createContract: {
    bodyKey: "createContractRequest",
    pathParams: { depId: (ctx) => ctx.auth.departmentId },
    bodyDefaults: { timezone: () => moment.tz.guess() },
  },
  createOrganizationEntry: {
    bodyKey: "createOrganizationEntryRequest",
    bodyDefaults: { industryIds: () => [], countryId: (ctx) => ctx.defaultCountryId },
  },
};
